<ng-template [ngIf]="element.altraParte.parte.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_FISICA">
<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
	[labelInput]="'Cognome e Nome'" [valueInput]="element.altraParte.parte.nominativo"></div>
</ng-template>
<ng-template [ngIf]="element.altraParte.parte.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_GIURIDICA">
<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
	[labelInput]="'Ragione sociale'" [valueInput]="element.altraParte.parte.nominativo"></div>
</ng-template>
<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
	[labelInput]="'Tipo beneficiario'" [valueInput]="element.altraParte.categoriaAltraParte?.label"></div>
<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
	[labelInput]="'Fattura'" [valueInput]="element.numeroFattura"></div>
<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'importo'"
	[labelInput]="'Importo'" [valueInput]="element.totaleImportoAttivita"></div>
